module.exports = __webpack_public_path__ + "static/media/ec-ui.f3dd2ffc.png";